import { mdiLoading } from '@mdi/js'
import Icon from '@mdi/react'
import { IconProps } from '@mdi/react/dist/IconProps'
import styled from 'styled-components'

import theme from 'theme_'

const RotatingIcon = styled(Icon)`
  animation: ${theme.animations.spin} 1s linear infinite;
`

interface SpinnerIconProps extends Omit<IconProps, 'path'> {
  path?: string
}

function Spinner({ size = 3, ...rest }: SpinnerIconProps) {
  return (
    <RotatingIcon
      path={mdiLoading}
      color={theme.colors.dimmedGold}
      size={size}
      horizontal
      vertical
      {...rest}
    />
  )
}

export default Spinner
